import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useEffect } from "react";
import { Close } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import TooltipIconButton from "components/TooltipIconButton";
import { useDispatch, useSelector } from "react-redux";
const Chart = (props => {
    const dispatch = useDispatch();
    const chartPoints = useSelector(state => state.settings.chartPoints);

    useEffect(() => {
        let chart = am4core.create("chartdiv", am4charts.XYChart);
        drawLineChart([]);

        return () => {
            chart.dispose();
        }
    }, [])

    useEffect(() => {
        drawLineChart(chartPoints);
    }, [chartPoints])

    function drawLineChart(points) {
        /* Chart code */
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv", am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        let data = [];
        let length = 0;
        let height = 0;

        for (var i = 0; i < points.length; i++) {
            length += 1 / 4; //for every 0.25m
            height = points[i].height.toFixed(2);
            data.push({ length: length, height: height });
        }

        chart.data = data;

        let heightAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        heightAxis.dataFields.category = "length";
        heightAxis.tooltip.disabled = true;

        let lengthAxis = chart.yAxes.push(new am4charts.ValueAxis());
        lengthAxis.tooltip.disabled = true;

        heightAxis.renderer.grid.template.stroke = "white";
        lengthAxis.renderer.grid.template.stroke = "white";
        chart.plotContainer.background.stroke = "white";
        lengthAxis.renderer.labels.template.fill = am4core.color("white");
        heightAxis.renderer.labels.template.fill = am4core.color("white");

        let series = chart.series.push(new am4charts.LineSeries());
        series.stroke = am4core.color("#3C78FA");
        series.strokeWidth = 5;
        series.dataFields.categoryX = "length";
        series.dataFields.valueY = "height";
        series.dataFields.valueX = "length";
        series.tooltipText = "Height: {valueY.value} m Distance: {valueX.value} m";
        series.sequencedInterpolation = true;
        series.fillOpacity = 0.3;
        series.tensionX = 0.8;

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.yAxis = heightAxis;
        chart.cursor.behavior = "panXY";

        chart.events.on("ready", function () {
        });
    }

    const closeChart = () => {
        dispatch({ type: 'TOGGLE_CHART', show: false })
    }

    return (
        <div style={{ position: 'absolute', bottom: 38, height: '350px', width: "100%", background: "#2F2F2F" }}>
            <IconButton onClick={closeChart} style={{ position: 'absolute', right: 0 }}>
                <Close style={{ color: "white" }} />
            </IconButton>
            <div id="chartdiv" style={{ position: 'absolute', top: 50 }} />
        </div>
    )
})

export default Chart;